/* RESPONSIBLE TEAM: team-fin-qa */
// Parent route for QA reviews in the inbox. Child routes are ReactRoutes.
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type RouterService from '@ember/routing/router-service';

export default class InboxWorkspaceReviewsRoute extends Route {
  @service declare session: Session;
  @service declare router: RouterService;

  queryParams = {
    page: { refreshModel: false },
    perPage: { refreshModel: false },
    reviewStatus: { refreshModel: false },
    reviewerId: { refreshModel: false },
    revieweeId: { refreshModel: false },
    filterMonitorId: { refreshModel: false },
    scorecardId: { refreshModel: false },
  };

  beforeModel() {
    if (!this.session.workspace.isFeatureEnabled('human-qa')) {
      this.router.transitionTo('inbox.workspace.inbox');
    }
  }
}
